import { SXStyleSheet } from '@/utils';

/**
 * Design-Test Stufe 2 (25.10.2026), Farben Stufe 2b: das Hover-Fenster der
 * eingeklappten Sidebar ist wieder Navy wie Original, aber flach — feiner
 * Rand statt Schatten, Eintraege wie in der Sidebar selbst (weiss, aktiv
 * Gold), keine Balken, keine Verlaeufe.
 */
const style = SXStyleSheet.create({
  container: {
    position: 'absolute',
    left: '100%',
    minWidth: 'fit-content',
    maxWidth: '280px',
    backgroundColor: 'background.navigation',
    border: '1px solid',
    borderColor: 'navigation.trenner',
    borderRadius: '8px',
    padding: '8px',
    marginLeft: '8px',
    boxShadow: 'none',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    pointerEvents: 'auto',
    overflow: 'hidden',
  },
  mainItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    transition: 'all 150ms ease-in-out',
  },
  // Schrift per variant am Element — sx.typography wuerde an einer
  // Typography die Aktiv-Farbe ueberstimmen.
  label: {
    color: 'navigation.text',
    whiteSpace: 'nowrap',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 12px',
    cursor: 'pointer',
    transition: 'background-color 150ms ease-in-out',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: 'background.navigationAktiv',
    },
  },
  activeLabel: {
    color: 'navigation.aktiv',
    backgroundColor: 'background.navigationAktiv',
  },
  subItemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingLeft: '8px',
    animation: 'slideIn 150ms ease-out',
  },
  divider: {
    backgroundColor: 'navigation.trenner',
    margin: '8px 0',
    height: '1px',
  },
  subItemLabel: {
    color: 'navigation.text',
    whiteSpace: 'nowrap',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 12px',
    cursor: 'pointer',
    transition: 'background-color 150ms ease-in-out',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: 'background.navigationAktiv',
      color: 'navigation.aktiv',
    },
  },
  activeSubItemLabel: {
    color: 'navigation.aktiv',
    fontWeight: 600,
    backgroundColor: 'background.navigationAktiv',
    '&:hover': {
      backgroundColor: 'background.navigationAktiv',
    },
  },
});

export default style;
